"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubmitOrderButton = void 0;
var react_1 = require("react");
var context_1 = require("../context/context");
var lib_1 = require("./lib");
var query_1 = require("./query");
function useSubmitOrderButton(onClick) {
    var _a = (0, context_1.useTwapContext)(), t = _a.translations, state = _a.state;
    var swapState = state.swapState, disclaimerAccepted = state.disclaimerAccepted;
    var isLoading = swapState === "loading";
    var setSwapSteps = (0, lib_1.useSetSwapSteps)();
    var allowanceLoading = query_1.query.useAllowance().isLoading;
    var loading = isLoading || allowanceLoading;
    var _onClick = (0, react_1.useCallback)(function () {
        setSwapSteps();
        onClick === null || onClick === void 0 ? void 0 : onClick();
    }, [setSwapSteps, onClick]);
    return {
        text: t.placeOrder,
        onClick: _onClick,
        loading: loading,
        disabled: loading || !disclaimerAccepted,
    };
}
exports.useSubmitOrderButton = useSubmitOrderButton;
